<template>
  <v-app>
    <v-container class="appclick">
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <router-link :to="{ name: 'settings_filter' }">
          <font-awesome-icon
            :icon="['fas', 'filter']"
            :style="{ color: 'green' }"
        /></router-link>
        <font-awesome-icon :icon="['fas', 'balance-scale']" />
        <span class="title"
          >Object filter by confidence level: traffic participant or not?</span
        >
      </Header>
      <v-row>
        <v-col class="col-12">
          <v-card flat color="transparent">
            <v-card-text>
              <v-row class="rowbox">
                <v-col class="col-5">
                  <v-subheader><b>Confidence level</b></v-subheader>
                  <v-slider
                    v-model="confidence"
                    :min="min"
                    class="align-center"
                    @change="ApiGet(false)"
                  >
                    <template v-slot:prepend>
                      <v-text-field
                        :value="confidence"
                        class="mt-0 pt-0"
                        single-line
                        type="number"
                        style="width: 60px"
                      ></v-text-field>
                    </template>
                  </v-slider>
                </v-col>
                <v-col class="col-2">
                  <br /><br />
                  <button @click="copySettings('field_confidence', confidence)">
                    Copy settings
                  </button>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-3">
          <div class="settings-tekst">
            <ol>
              <b>Detect the non-traffic participants</b>
              <li>Choose minimum confidence level</li>
              <li>Click 'Get objects'</li>
              <li>
                You get random objects (max
                {{ this.stats.n_check }})
              </li>
              <li>Click image if it's not a traffic participant</li>
            </ol>
          </div>
        </v-col>
        <v-col class="col-3">
          <p style="background-color:yellow">
            Moving or non-checked objects: {{ this.n_traffic }}
          </p>
        </v-col>
        <v-col class="col-3">
          <p style="background-color:lightblue">
            Non traffic participants: {{ this.n_nontraffic }}
          </p>
        </v-col>
        <v-col class="col-3">
          Percentage non traffic participants:
          {{
            Math.round(
              (100 * this.n_nontraffic) / (this.n_traffic + this.n_nontraffic)
            )
          }}%
        </v-col>
      </v-row>
      <div
        id="scroll-target"
        style="max-height: 520px;"
        class="overflow-y-auto"
      >
        <v-row
          class="maps"
          v-scroll:#scroll-target="onScroll"
          align="center"
          justify="center"
          style="width:1250px"
        >
          <v-col class="col-12">
            <div
              :id="'mapdiv[' + indextd + ']'"
              class="mapclassdiv"
              v-for="indextd in this.n_blocks"
              :key="indextd"
              @click="clickimage(indextd)"
            >
              <div class="summary" :id="'summary[' + indextd + ']'">
                {{ summary[indextd] }}
              </div>
              <div class="mapmap" :id="'map[' + indextd + ']'"></div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-app>
</template>
<script>
import ProjectService from "@/services/ProjectService.js";
import Header from "@/components/Header.vue";

import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Vector as VectorSource } from "ol/source";
import ImageLayer from "ol/layer/Image";
import { Vector as VectorLayer } from "ol/layer";
import { Fill, Stroke, Style, Text } from "ol/style";
import GeoJSON from "ol/format/GeoJSON";
import Static from "ol/source/ImageStatic";
import Projection from "ol/proj/Projection";
import { getCenter } from "ol/extent";
var vectorsource;
var vectorlayer;
var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});
var style = new Style({
  fill: new Fill({
    color: "rgba(255, 0, 0, 0.1)"
  }),
  stroke: new Stroke({
    color: "#FF0000",
    width: 2
  }),
  text: new Text({
    font: "30px Calibri,sans-serif",
    fill: new Fill({
      color: "#0000ff"
    }),
    stroke: new Stroke({
      color: "#0000ff",
      width: 2
    })
  })
});
export default {
  components: {
    Header
  },
  data: function() {
    return {
      routes: {},
      objects: {},
      object: {},
      map: null,
      n_traffic: 0,
      n_nontraffic: 0,
      min: 0,
      max: 100,
      stats: {},
      n_blocks: 50,
      confidence: 0,
      summary: [],
      width: 256,
      height: 0.666666 * 216 + 20,
      zoom: 0
    };
  },
  computed: {
    cssVars() {
      return {
        "--width": this.width + "px",
        "--height": this.height + "px"
      };
    }
  },
  mounted() {
    this.ApiGet(true);
  },
  methods: {
    ApiGet(start) {
      let vars = { confidence: this.confidence };
      ProjectService.apiGet({
        nid: this.$session.get("PROJID"),
        type: "settings_filter_confidence",
        vars
      })
        .then(response => {
          if (start) {
            this.confidence = response.data.fields.field_confidence;
          }
          this.objects = response.data.data;
          this.stats = this.objects[0];
          this.n_traffic = this.stats.n_check;
          if (this.n_traffic > 0) {
            this.summary = response.data.summary;
            this.n_nontraffic = 0;
            for (var j = 1; j <= this.n_blocks; j++) {
              let el1 = document.getElementById("mapdiv[" + j + "]");
              let el2 = document.getElementById("map[" + j + "]");
              el2.innerHTML = "";
              if (j <= this.stats.n_check) {
                el1.style.display = "inline-block";
                el1.style.backgroundColor = "yellow";
                this.changeObject(j);
              } else {
                el1.style.display = "none";
              }
            }
          } else {
            let message = {
              title: "No records found!"
            };
            this.$dialog.alert(message);
          }
        })
        .catch(error => {
          console.log("Fout " + error.response);
        });
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    clickimage(nr) {
      let el = document.getElementById("mapdiv[" + nr + "]");
      if (
        !el.style.backgroundColor ||
        el.style.backgroundColor == "lightblue"
      ) {
        el.style.backgroundColor = "yellow";
        this.n_traffic++;
        this.n_nontraffic--;
      } else {
        el.style.backgroundColor = "lightblue";
        this.n_traffic--;
        this.n_nontraffic++;
      }
    },
    copySettings(field, value) {
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "update_fields",
        field,
        value
      });
    },
    changeObject(o_slider) {
      this.object = this.objects[o_slider];
      var graph_id = this.object.obj;
      var show_id = this.object.frame;
      vectorsource = new VectorSource({
        format: new GeoJSON(),
        url:
          "https://trafficdistillery.com/tracking/getmosaicgraph/" +
          this.$session.get("PROJID") +
          "/" +
          graph_id
      });
      var image = new ImageLayer({
        source: new Static({
          url:
            "https://trafficdistillery.com/sites/default/files/project/" +
            this.$session.get("PROJID") +
            "/images/" +
            show_id +
            ".jpg",
          projection: projection,
          size: [this.width, this.height],
          imageExtent: extent
        })
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: function(feature) {
          style.getText().setText(feature.get("label"));
          return style;
        }
      });
      var map = new Map({
        layers: [image, vectorlayer],
        interactions: [],
        controls: [],
        view: new View({
          controls: [],
          interactions: [],
          projection: projection,
          center: getCenter(extent),
          zoom: this.zoom,
          attribution: false
        })
      });
      map.setTarget("map[" + o_slider + "]");
    }
  }
};
</script>

<style scoped>
.mapclassdiv {
  height: 189px;
  width: 256px;
  margin-left: 22px;
  margin-right: 22px;
  margin-bottom: 5px;
}
.mapmap {
  height: 166px;
  width: 256px;
  display: inline-block;
}
.summary {
  font-size: 0.9em;
  display: inline-block;
  width: 100%;
}
.align-center {
  border-style: solid;
  border-width: thin;
}
.button,
button {
  align-items: center;
  justify-content: center;
  width: 8em;
  height: 2em;
  margin-left: 0.5em;
  padding: none;
  border-radius: 5px;
  background: linear-gradient(to right, #16c0b0, #84cf6a);
  font-size: 1em;
  color: white;
  border: none;
  outline: none;
}
.toel {
  font-size: 0.7em;
}
.settings-tekst li {
  display: none;
}
</style>
